import { Component, NgModule, trigger, transition, style, animate, state } from '@angular/core';
import { DispatcherService } from '../../dispatcher/dispatcher.service';
import { DispatcherHomeService } from '../dispatcherhome/dispatcherhome.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { LanguageService } from '../../language.service';
import { ConfigService } from '../../config.service';
import { Observable } from 'rxjs/Observable';
declare var jQuery: any;
declare var $: any;
declare var Stripe: any;
declare var PUBNUB: any;
declare var swal: any;
declare var moment: any;
declare var flatpickr: any;
declare var toastr: any;
@Component({
  selector: 'wallet',
  animations: [
    trigger(
      'myAnimation',
      [
        transition(
          ':enter', [
            style({ transform: 'translateX(100%)', opacity: 0 }),
            animate('400ms', style({ transform: 'translateX(0)', 'opacity': 1 }))
          ]
        ),
        transition(
          ':leave', [
            style({ transform: 'translateX(0)', 'opacity': 1 }),
            animate('500ms', style({ transform: 'translateX(-100%)', 'opacity': 0 }),
            )
          ]
        )]
    )
  ],
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.css']
})
export class WalletComponent {
  online$: Observable<boolean>;
  wallet: any;

  softlimit: any;
  hardlimit: any;
  amount: any;
  credit_trans = [];
  debit_trans = [];
  all_trans = [];
  alltrans_history = true;
  debittrans_history = false;
  credittrans_history = false;
  show_trans_loader = true;
  page_index: number = 0;
  allcards = [];
  payable_amount: any;
  show_load_more = false;
  show_card_error = false;
  show_cardid_error = false;
  card_number_all: any;
  visa = false;
  amex = false;
  discover = false;
  jcb = false;
  diners = false;
  master = false;

  newcarderror = false;
  card_num_error = false;
  card_month_error = false;
  card_year_error = false
  card_cvv_error = false;
  month: any;
  year: any;
  cvv: any;
  show_cards_loader = true;
  show_page_loader = false;
  stripe_error: any;
  pubnub: any;
  show_soft_marker = false;
  show_hard_marker = false;
  pubnub_keys_pk: any;
  pubnub_keys_sk: any;
  currency: any;
  last_four: any;
  card_type: any;
  walletRechargeAmount: any;

  errMsg: any;
  errmessage: any;

  move_next(input, $event) {                           // credit card validation and pass number to card type check
    if ($event.target.value.length == 4) {
      $(".numbers-" + (input + 1)).focus();
    }
    else if ($event.target.value.length == 0 && input > 1) {
      $(".numbers-" + (input - 1)).focus();
    }
    var card_number = "";
    $('.phone_num_valid').each(function () {
      var each_value = $(this).val() + ' ';
      if (each_value != '') {
        card_number += $(this).val() + ' ';
      }
    })
    this.card_number_all = card_number.replace(/ /g, '');
    this.GetCardType(this.card_number_all);
  }

  GetCardType(number) {                               // checks card type and shows in when adding new card
    this.visa = false;
    this.amex = false;
    this.discover = false;
    this.jcb = false;
    this.diners = false;
    this.master = false;
    // visa
    var re = new RegExp("^4");
    if (number.match(re) != null) {
      this.visa = true;
      return "Visa";
    }
    // Mastercard
    re = new RegExp("^5[1-5]");
    if (number.match(re) != null) {
      this.master = true;
      return "Mastercard";
    }
    // AMEX
    re = new RegExp("^3[47]");
    if (number.match(re) != null) {
      this.amex = true;
      return "AMEX";
    }
    // Discover
    re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
    if (number.match(re) != null) {
      this.discover = true;
      return "Discover";
    }
    // Diners
    re = new RegExp("^36");
    if (number.match(re) != null) {
      this.diners = true;
      return "Diners";
    }
    // Diners - Carte Blanche
    re = new RegExp("^30[0-5]");
    if (number.match(re) != null) {
      this.diners = true;
      return "Diners - Carte Blanche";
    }
    // JCB
    re = new RegExp("^35(2[89]|[3-8][0-9])");
    if (number.match(re) != null) {
      this.jcb = true;
      return "JCB";
    }
    // Visa Electron
    re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
    if (number.match(re) != null) {
      this.visa = true;
      return "Visa Electron";
    }
    return "NOT";
  }

  check_month() {
    if (this.month > 12) {
      this.month = ""
    }
  }

  month_validate() {
    if (this.month > 12 || this.month == '') {
      this.card_month_error = true;
    }
    else {
      this.card_month_error = false;
    }
  }
  year_validate() {
    if (this.year < 2018 || this.year == '') {
      this.card_year_error = true;
    }
    else {
      this.card_year_error = false;
    }
  }
  validate_card() {
    var card = $(".numbers-1").val() + $(".numbers-2").val() + $(".numbers-3").val() + $(".numbers-4").val();
    if (card.length < 14) {
      this.card_num_error = true;
    }
    else {
      this.card_num_error = false;
    }

    if (this.month == '' || this.month == undefined || this.card_month_error) {
      this.card_month_error = true;
    }
    else {
      this.card_month_error = false;
    }

    if (this.year == '' || this.year == undefined || this.card_year_error) {
      this.card_year_error = true;
    }
    else {
      this.card_year_error = false;
    }
    if (this.cvv == '' || this.cvv == undefined) {
      this.card_cvv_error = true;
    }
    else {
      this.card_cvv_error = false;
    }

    if (this.card_cvv_error == false && this.card_month_error == false && this.card_num_error == false && this.card_year_error == false) {
      this.show_page_loader = true;
      this.stripe_cardadd();
    }
    else {

    }
  }

  select_input() {
    this.card_num_error = false;
    this.card_month_error = false;
    this.card_year_error = false;
    this.card_cvv_error = false;
    $("#card-flip").attr('checked', false);
    setTimeout(() => {
      $(".first_card_field").focus();
    }, 600)
  }

  show_alert() {
    var cardid = $("input[name=card_selection]:checked").attr('value');
    this.last_four = $("label[for=" + cardid + "]").attr('id');
    this.card_type = $("label[for=" + cardid + "]").attr('title');
    if (this.payable_amount == undefined || this.payable_amount == '') {
      swal("Amount not added!", "Please enter the amount to continue!", "error");
      this.show_card_error = true;
    }
    else {
      this.show_card_error = false;
      if (cardid == undefined || cardid == '') {
        // this.show_cardid_error = true;
        swal("Card not selected!", "Please select a card to continue!", "error");
      }
      else {
        $("#recharge_wallet_alert").modal('show');
      }
    }
  }

  change_amt() {
  }

  gettransactions(val) {
    if (val == 0)             // show all transactions
    {
      $("#transaction_list li a").removeClass('active');
      $(".all_trans").addClass('active');
      this.debittrans_history = false;
      this.alltrans_history = true;
      this.credittrans_history = false;
    }
    else if (val == 1)             // show all transactions
    {
      $("#transaction_list li a").removeClass('active');
      $(".debit_trans").addClass('active');
      this.alltrans_history = false;
      this.debittrans_history = true;
      this.credittrans_history = false;
    }
    else if (val == 2)             // show all transactions
    {
      $("#transaction_list li a").removeClass('active');
      $(".credit_trans").addClass('active');
      this.credittrans_history = true;
      this.alltrans_history = false;
      this.debittrans_history = false;
    }
  }

  ngOnInit() {
    this.walletData();
    this.wallet = this.languageService.wallet;

    if (this._cookie.getItem('token') == undefined) {
      this._router.navigate(['login']);
    }

    $(".booking_buutns").hide();
    $("#back_button").show();
    this.softlimit = parseInt(this._cookie.getWalletDetails('walletSoftLimit'));
    this.hardlimit = parseInt(this._cookie.getWalletDetails('walletHardLimit'));
    this.amount = parseInt(this._cookie.getWalletDetails('walletBalance'));
    this.currency = this._cookie.getWalletDetails('currencySymbol');

    this.walletLimit();

    this.getpayment_details();
    this.getallcards();
    this.appconfig_url();
    this.getwallettransactions();
    $('.phone_num_valid,#amount_text').keypress(function (event) {
      var $this = $(this);
      if ((event.which != 46 || $this.val().indexOf('.') != -1) &&
        ((event.which < 48 || event.which > 57) &&
          (event.which != 0 && event.which != 8))) {
        event.preventDefault();
      }

      var text = $(this).val();
      if ((event.which == 46) && (text.indexOf('.') == -1)) {
        setTimeout(function () {
          if ($this.val().substring($this.val().indexOf('.')).length > 3) {
            $this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
          }
        }, 1);
      }

      if ((text.indexOf('.') != -1) &&
        (text.substring(text.indexOf('.')).length > 2) &&
        (event.which != 0 && event.which != 8) &&
        ($(this)[0].selectionStart >= text.length - 2)) {
        event.preventDefault();
      }
    });

    $('#creditcard_wallet').on('hidden.bs.modal', () => {
      $(".phone_num_valid,#addnew_cardname,.month,.year,#cvv_code").val('');
      this.card_number_all = "";
      this.cvv = "";
      this.month = "";
      this.year = "";
      $('.add_card_error').hide();
    });
    $('#wallet_update').click(() => {
      this.credit_trans = [];
      this.debit_trans = [];
      this.all_trans = [];
      this.getpayment_details();
      this.getwallettransactions();
      this.show_page_loader = false;
    })
    $('#card-holder').on('keyup change', function ($event) {
      $('.credit-card-box .card-holder div').html($event.target.value);
    });
    $("#amount_text").focus(() => {
      this.show_card_error = false;
    })
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": false,
      "progressBar": true,
      "positionClass": "toast-top-left",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "8000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }

    $("#wallet_balance").change(() => {
      this.walletData();
      this.getpayment_details();
      this.getwallettransactions();
    });
  }
  constructor(private _cookie: ConfigService, private _dispatcherService: DispatcherService, private _router: Router, private _dispatcherHomeService: DispatcherHomeService, private languageService: LanguageService) {
    this.online$ = Observable.merge(
      Observable.of(navigator.onLine),
      Observable.fromEvent(window, 'online').mapTo(true),
      Observable.fromEvent(window, 'offline').mapTo(false)
    )
  }

  // START OF UBER FOR ALL API CALLS
  // app config function api 
  appconfig_url() {
    this._dispatcherService.appconfig({}).subscribe((res) => {
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 520:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this.errMsg = JSON.parse(err._body);
            this._cookie.removeItem();
            this._router.navigate(['login']);
            toastr["warning"](this.errMsg.message + "<br> You have been Logged out!");
            break;
          case 420:
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            break;
        }
      });
  }
  stripe_cardadd() {
    this.stripe_error = "";
    var stripekey = this._cookie.getConfig('stripe');
    Stripe.setPublishableKey(stripekey);
    Stripe.createToken({
      number: parseInt(this.card_number_all),
      cvc: parseInt(this.cvv),
      exp_month: (this.month).toString(),
      exp_year: (this.year).toString()
    }, (status, response) => {
      if (response.error != undefined) {
        this.show_page_loader = false;
        this.stripe_error = " * " + response.error.message;
      }
      else {
        this.stripe_error = "";
        if (response['id'] != undefined) {
          this.addcards(response['id']);
        }
        else {
          $(".error_card_msg").css('color', 'red');
          $(".error_card_msg").text(response.error.message);
          $(".loader_cardadd_parent").hide();
        }
      }
    })
  }
  // card details
  getallcards() {
    this.show_cards_loader = true;
    this._dispatcherService.getcards({
    }).subscribe((res) => {
      $(".loader_cardadd_parent").hide();
      this.allcards = res.data.cards;
      setTimeout(() => {
        if (this.allcards.length > 0) {
          for (var inst = 0; inst < this.allcards.length; inst++) {
            if (this.allcards[inst].isDefault == true) {
              $("#" + this.allcards[inst].id).attr('checked', true);
              this.last_four = this.allcards[inst].last4;
              this.card_type = this.allcards[inst].funding;
              break;
            }
          }
        }
        this.show_cards_loader = false;
        this.show_page_loader = false;
      }, 500);
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 520:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this.errMsg = JSON.parse(err._body);
            this._cookie.removeItem();
            this._router.navigate(['login']);
            toastr["warning"](this.errMsg.message + "<br> You have been Logged out!");
            break;
          case 420:
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            break;
        }
      });
  }
  // add cards
  addcards(cardid) {
    this._dispatcherService.addcards({
      email: this._cookie.getItem('email'),
      cardToken: cardid,
    }).subscribe((res) => {
      this.show_cards_loader = true;
      $(".phone_num_valid").val('');
      $("#addnew_cardname").val('');
      this.card_number_all = '';
      this.month = undefined;
      this.year = undefined;
      this.cvv = undefined;
      this.allcards = [];
      this.getallcards();
      $("#creditcard_wallet").modal('hide');
      swal("Card added!", "Card successfully added !", "success");
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 520:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this.errMsg = JSON.parse(err._body);
            this._cookie.removeItem();
            this._router.navigate(['login']);
            toastr["warning"](this.errMsg.message + "<br> You have been Logged out!");
            break;
          case 420:
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            break;
        }
      });
  }
  // delete card
  deleteCard() {
    this.show_page_loader = true;
    var cardid = $("input[name=card_selection]:checked").attr('value');
    this._dispatcherService.deletecard({
      "cardId": cardid,
    }).subscribe((res) => {
      for (var inst = 0; inst < this.allcards.length; inst++) {
        if (this.allcards[inst].id == cardid) {
          this.allcards.splice(inst, 1);
          break;
        }
      }
      $("#warning_card_popup").modal('hide');
      if (this.allcards.length > 0)
        $("#" + this.allcards[0].id).attr('checked', true);
      this.show_page_loader = false;
      swal("Card deleted!", "Card deleted successfully !", "success");
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 520:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this.errMsg = JSON.parse(err._body);
            this._cookie.removeItem();
            this._router.navigate(['login']);
            toastr["warning"](this.errMsg.message + "<br> You have been Logged out!");
            break;
          case 420:
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            break;
        }
      });
  }
  pay_now() {
    var cardid = $("input[name=card_selection]:checked").attr('value');
    this.last_four = $("label[for=" + cardid + "]").attr('id');
    this.card_type = $("label[for=" + cardid + "]").attr('title');
    if (this.payable_amount == undefined || this.payable_amount == '') {
      this.show_card_error = true;
    }
    else {
      this.show_card_error = false;
      if (cardid == undefined || cardid == '') {
        this.show_cardid_error = true;
      }
      else {
        this.show_page_loader = true;
        this.recharge_call(cardid);
      }
    }
  }
  walletLimit() {
    if (this.amount < this.softlimit && this.amount > this.hardlimit) {
      this.show_soft_marker = true;
      this.show_hard_marker = false;
    } else {
      if (this.amount <= this.hardlimit) {
        this.show_hard_marker = true;
        this.show_soft_marker = false;
      }
      else {
        this.show_hard_marker = false;
        this.show_soft_marker = false;
      }
    }
  }
  // wallet data
  walletData() {
    this._dispatcherService.wallet({}).subscribe((res) => {
      this.walletLimit();
      this._cookie.setWalletDetails(res.data);
      this.currency = res.data.currencySymbol;
      this.amount = this._cookie.getWalletDetails('walletBalance');
      $("#wallet_balance").text(this.amount);
      $('#s-option1').text(this.amount);
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 520:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this.errMsg = JSON.parse(err._body);
            this._cookie.removeItem();
            this._router.navigate(['login']);
            toastr["warning"](this.errMsg.message + "<br> You have been Logged out!");
            break;
          case 420:
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            break;
        }
      });
  }
  // recharge wallet
  recharge_call(cardid) {
    this._dispatcherService.recharge({
      "cardId": cardid,
      "amount": this.payable_amount,
    }).subscribe((res) => {
      this.credit_trans = [];
      this.debit_trans = [];
      this.all_trans = [];
      this.show_cardid_error = false;
      this.walletData();
      this.getpayment_details();
      this.getwallettransactions();
      this.payable_amount = "";
      this.show_page_loader = false;
      swal("Transaction success!", "Payment done !", "success")
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $('.page_loader').hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 520:
            $('.page_loader').hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $('.page_loader').hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            $('.page_loader').hide();
            this.errMsg = JSON.parse(err._body);
            this._cookie.removeItem();
            this._router.navigate(['login']);
            toastr["warning"](this.errMsg.message + "<br> You have been Logged out!");
            break;
          case 420:
            $('.page_loader').hide();
            this.walletRechargeAmount = JSON.parse(err._body);
            this.walletRechargeAmount = this.walletRechargeAmount.message;
            setTimeout(() => {
              this.walletRechargeAmount = '';
            }, 1000);
            console.log(this.walletRechargeAmount);
            break;
        }
      });
  }

  loadmore_trans() {
    this.show_trans_loader = true;
    this.page_index++;
    this.getwallettransactions();
  }
  // wallet transactions
  getwallettransactions() {
    var sid = sessionStorage.getItem('sid');
    this._dispatcherService.wallettrans({
      "pageIndex": this.page_index.toString()
    }).subscribe((res) => {
      if (res.data.creditTransctions.length == 0 && res.data.debitTransctions.length == 0 && res.data.creditDebitTransctions.length == 0) {
        $(".more_tooltip_error").show();
        setTimeout(function () { $(".more_tooltip_error").hide(); }, 2000);
        this.show_trans_loader = false;
        this.show_load_more = true;
      }
      else {
        for (var inst = 0; inst < res.data.creditTransctions.length; inst++) {
          var txnDate = moment.unix(res.data.creditTransctions[inst].txnDate).format("MMMM DD YYYY, hh:mm:ss a");
          res.data.creditTransctions[inst].txnDate = txnDate;
          this.credit_trans.push(res.data.creditTransctions[inst]);
        }
        for (var inst = 0; inst < res.data.debitTransctions.length; inst++) {
          var txnDate = moment.unix(res.data.debitTransctions[inst].txnDate).format("MMMM DD YYYY, hh:mm:ss a");
          res.data.debitTransctions[inst].txnDate = txnDate;
          this.debit_trans.push(res.data.debitTransctions[inst]);
        }
        for (var inst = 0; inst < res.data.creditDebitTransctions.length; inst++) {
          var txnDate = moment.unix(res.data.creditDebitTransctions[inst].txnDate).format("MMMM DD YYYY, hh:mm:ss a");
          res.data.creditDebitTransctions[inst].txnDate = txnDate;
          this.all_trans.push(res.data.creditDebitTransctions[inst]);
        }
        this.show_trans_loader = false;
      }
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 520:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this.errMsg = JSON.parse(err._body);
            this._cookie.removeItem();
            this._router.navigate(['login']);
            toastr["warning"](this.errMsg.message + "<br> You have been Logged out!");
            break;
          case 420:
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            break;
        }
      });
  }
  // payment details
  getpayment_details() {
    this._dispatcherService.payment({
    }).subscribe((res) => {
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 520:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this.errMsg = JSON.parse(err._body);
            this._cookie.removeItem();
            this._router.navigate(['login']);
            toastr["warning"](this.errMsg.message + "<br> You have been Logged out!");
            break;
          case 420:
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            break;
        }
      }
    );
  }

  // END OF UBER FOR ALL API CALLS

}




// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/dispatcher/wallet/wallet.component.ts